/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
		<Path d="M14 6H6v8h1.5V8.5L17 18l1-1-9.5-9.5H14V6Z" />
	</SVG>
);
